import api from "./api.js";

export default class PointApi {
  static async getSettingInfo() {
    return await api.get(`api/point/1`);
  }

  static async editSetting(data) {
    return await api.patch(`api/point/1`, data);
  }

  static async getEventInfo() {
    return await api.get(`api/point-event/1`);
  }

  static async editEvent(data) {
    return await api.patch(`api/point-event/1`, data);
  }

  static async getPointHistoryList(data) {
    return await api.get(`api/point-history`, data);
  }
}
